import React from 'react';
import SubComponents from '../Common/SubComponent';
import * as stateUtil from '../util/componetState';
import * as html from '../util/html';
import './formPart.scss';
import classnames from 'classnames';


function Title(props) {
    return (<div className="form-part-title">{props.title}</div>);
}

class FormPart extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //Formart用visible来控制显示隐藏
        let inVisible = !this.props.cmp_data.visible;
        let hasVisible = true;
        if(this.props.sub_cmps) {
            if(toString.call(this.props.sub_cmps) !== '[object Array]') {
                return;
            }

            hasVisible = this.props.sub_cmps.some(obj => {
                return stateUtil.isInvisible(obj.cmp_data) === false;
            });

        }

        if(!hasVisible || inVisible) {
            return null;
        }
        const { title, showTitle, promptMessage } = this.props.cmp_data;
        return (
            <div className="form-part">
                {showTitle && title ? <Title title={title} /> : null}
                {showTitle && title && promptMessage ? <div className='form-part-desc'><pre className='prompt-pre-html'>{html.decode(promptMessage)}</pre></div> : null}
                <div className={classnames('form_part_com', { 'oneFormpart': this.props.oneFormpart })}>
                <SubComponents {...this.props}  biz_data={this.props.biz_data} getRefreshParams={this.props.getRefreshParams} />
                </div>
            </div>
        );
    }
}

FormPart.defaultProps = {
    cmp_data: {},
    sub_cmps: [],
    form_errors: {}
};

FormPart.PropTypes = {
    cmp_data: React.PropTypes.object.required,
    sub_cmps: React.PropTypes.array.required,
    form_errors: React.PropTypes.object
};

export default FormPart;



// WEBPACK FOOTER //
// ./src/components/Form/FormPart.js